import { type DefaultValues } from 'react-hook-form';

import { type OnboardingDataDraft } from '@/modules/rulesEngine';

import { type CreateProfileFormValues } from '../schema/createProfileSchema';

// Rebuilds form defaults from the draft so the form restores on
// navigate-away-and-back. `height` is stored as total inches; split it back
// into feet + inches. 0/empty values map to '' so required validation fires
// instead of showing a stale "0".
export const mapDraftToFormValues = (
  draft: OnboardingDataDraft
): DefaultValues<CreateProfileFormValues> => {
  const height = draft.height ?? 0;
  const weight = draft.weight ?? 0;

  return {
    feet: height > 0 ? String(Math.floor(height / 12)) : '',
    inches: height > 0 ? String(height % 12) : '',
    weight: weight > 0 ? String(weight) : '',
    gender: draft.gender ?? '',
    ethnicity: draft.ethnicity ?? '',
  };
};
